"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __param = (this && this.__param) || function (paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Header = exports.AgreementModalComponents = exports.AgreementStore = exports.AgreementModal = void 0;
var kaleidoscope_1 = require("@qwilr/kaleidoscope");
var icons_1 = require("@qwilr/kaleidoscope/icons");
var pages_common_1 = require("@qwilr/pages-common");
var dynamic_1 = require("@vanilla-extract/dynamic");
var inversify_1 = require("inversify");
var inversify_react_1 = require("inversify-react");
var mobx_1 = require("mobx");
var mobx_react_1 = require("mobx-react");
var react_1 = __importStar(require("react"));
var scroll_into_view_if_needed_1 = __importDefault(require("scroll-into-view-if-needed"));
var DIProvider_1 = require("@CommonFrontend/DIProvider/DIProvider");
var ModalContainer_1 = require("@CommonFrontend/Modal/ModalContainer");
var AngularSyncStore_1 = __importStar(require("@CommonFrontend/Utils/AngularSyncStore"));
var AgreementBlockContainer_1 = require("./AgreementBlockContainer");
var AgreementContextProvider_1 = require("./AgreementContextProvider");
var styles = __importStar(require("./AgreementModal.css"));
var AcceptButtonSettingsHelper_1 = require("@CommonFrontendBackend/Accept/AcceptButtonSettingsHelper");
var MaybeWrap_1 = __importDefault(require("@CommonFrontend/Utils/MaybeWrap"));
var hydrate_1 = require("@CommonFrontend/Public/Widgets/hydrationHelpers/hydrate");
var Utils_1 = require("@CommonFrontend/AcceptFlow/ReactComponents/Utils");
var classnames_1 = __importDefault(require("classnames"));
var Utils_2 = require("./Utils");
var tokens_1 = require("@qwilr/kaleidoscope/tokens");
var DEFAULT_PERSIST_TIME = 5000;
var agreementModalOffset = 1054;
exports.AgreementModal = (0, mobx_react_1.observer)(function (_a) {
    var _b;
    var onDismiss = _a.onDismiss, isEditable = _a.isEditable, isLockedByBlockPermission = _a.isLockedByBlockPermission;
    var _c = __read((0, react_1.useState)(false), 2), isNavDrawerOpen = _c[0], setIsNavDrawerOpen = _c[1];
    var _d = __read((0, react_1.useState)(), 2), notificationMessage = _d[0], setNotificationMessage = _d[1];
    var _e = __read((0, react_1.useState)([]), 2), navItems = _e[0], setNavItems = _e[1];
    var agreementStore = (0, inversify_react_1.useInjection)(AgreementStore);
    var components = (0, inversify_react_1.useInjection)(exports.AgreementModalComponents.$);
    var formWrapperRef = (0, react_1.useRef)(null);
    var _f = __read((0, react_1.useState)(true), 2), modalEscapable = _f[0], setModalEscapable = _f[1];
    var agreementBlock = agreementStore.block;
    (0, react_1.useEffect)(function () {
        if (agreementBlock) {
            var items = (0, Utils_2.getHeadingsFromBlock)(agreementBlock);
            setNavItems(items);
        }
    }, [agreementBlock]);
    (0, react_1.useEffect)(function () {
        if (notificationMessage && (notificationMessage === null || notificationMessage === void 0 ? void 0 : notificationMessage.length) > 0) {
            setTimeout(function () {
                setNotificationMessage("");
            }, DEFAULT_PERSIST_TIME);
        }
    }, [notificationMessage]);
    if (!agreementBlock) {
        return (react_1.default.createElement(components.AgreementContextProvider, null,
            react_1.default.createElement(AgreementModalContainer, { onDismiss: onDismiss, showModal: agreementStore.showModal, modalEscapable: true },
                react_1.default.createElement(exports.Header, { type: "lite", onDismiss: onDismiss }),
                react_1.default.createElement(kaleidoscope_1.Stack, { className: styles.spinner, align: "center", justify: "center" },
                    react_1.default.createElement(kaleidoscope_1.Spinner, { primary: true })))));
    }
    return (react_1.default.createElement(components.AgreementContextProvider, null,
        react_1.default.createElement(AgreementModalContainer, { onDismiss: onDismiss, showModal: agreementStore.showModal, modalEscapable: modalEscapable, agreementBlock: agreementBlock },
            react_1.default.createElement(MaybeWrap_1.default, { wrapper: function (children) {
                    if (components.ErrorBoundary) {
                        return react_1.default.createElement(components.ErrorBoundary, { onDismiss: onDismiss }, children);
                    }
                } },
                react_1.default.createElement(exports.Header, { type: "full", onDismiss: onDismiss, agreementStore: agreementStore, agreementBlock: agreementBlock, formWrapperRef: formWrapperRef, setNotificationMessage: setNotificationMessage, setNavDrawerOpen: setIsNavDrawerOpen, navDrawerOpen: isNavDrawerOpen, isEditable: isEditable }),
                react_1.default.createElement("div", { className: styles.body, style: (0, dynamic_1.assignInlineVars)((_b = {},
                        _b["--signature-slot-background"] = tokens_1.palette.yellow100,
                        _b["--signature-slot-border"] = tokens_1.palette.yellow300,
                        _b["--signature-slot-hover"] = tokens_1.palette.yellow200,
                        _b)) },
                    react_1.default.createElement(components.AgreementNavigationDrawer, { agreementTitle: !!agreementStore.blockName ? agreementStore.blockName : "Untitled", navItems: navItems, isOpen: agreementStore.showNavigation === false ? false : isNavDrawerOpen, close: function () {
                            setIsNavDrawerOpen(false);
                        }, onDrawerToggle: function (isOpen) {
                            setModalEscapable(!isOpen);
                        }, onClick: function (idx) {
                            var agreementBlockElement = document.querySelector(".project-block.Agreement");
                            var headings = agreementBlockElement === null || agreementBlockElement === void 0 ? void 0 : agreementBlockElement.querySelectorAll("h1.project-block__block-element:not(.project-block__block-element .project-block__block-element), h2.project-block__block-element:not(.project-block__block-element .project-block__block-element), h3.project-block__block-element:not(.project-block__block-element .project-block__block-element), h4.project-block__block-element:not(.project-block__block-element .project-block__block-element)");
                            var element = headings === null || headings === void 0 ? void 0 : headings[idx];
                            if (element) {
                                element.scrollIntoView({ behavior: "smooth", block: "start" });
                            }
                        } }),
                    react_1.default.createElement(kaleidoscope_1.Stack, { paddingBottom: "l", className: styles.content },
                        react_1.default.createElement("div", { className: styles.notification },
                            react_1.default.createElement(kaleidoscope_1.Notification, { isShowing: !!notificationMessage, onClose: function () { return setNotificationMessage(""); }, type: kaleidoscope_1.NotificationType.Error }, notificationMessage)),
                        components.BlockActionsMenu && react_1.default.createElement(components.BlockActionsMenu, { block: agreementBlock }),
                        react_1.default.createElement(AgreementBlockContainer_1.AgreementBlockContainer, { block: agreementBlock, isLockedByBlockPermission: isLockedByBlockPermission },
                            react_1.default.createElement(components.BlockContent, null)),
                        react_1.default.createElement("div", { ref: formWrapperRef },
                            react_1.default.createElement(components.AcceptForm, { customisation: { buttonText: agreementStore.formButtonText } }))))))));
});
var AgreementStore = (function (_super) {
    __extends(AgreementStore, _super);
    function AgreementStore(angularSyncServices, angularData) {
        var _this = _super.call(this, angularData, angularSyncServices, {
            extractDataFromAngular: function (initialData) {
                return { showAgreementModal: initialData.showAgreementModal, agreementBlock: initialData.agreementBlock };
            },
        }) || this;
        _this.onAngularUpdated = function (newData) {
            _this._showModal = newData.showAgreementModal;
            _this._agreementBlock = newData.agreementBlock;
        };
        _this.onAngularUpdated(angularData);
        return _this;
    }
    Object.defineProperty(AgreementStore.prototype, "dataForAngular", {
        get: function () {
            return { showAgreementModal: this._showModal, agreementBlock: this._agreementBlock };
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(AgreementStore.prototype, "showModal", {
        get: function () {
            return this._showModal;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(AgreementStore.prototype, "block", {
        get: function () {
            return this._agreementBlock;
        },
        set: function (newBlock) {
            this._agreementBlock = newBlock;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(AgreementStore.prototype, "showNavigation", {
        get: function () {
            var _a, _b;
            return (_b = (_a = this._agreementBlock) === null || _a === void 0 ? void 0 : _a.settings.showNavigation) !== null && _b !== void 0 ? _b : true;
        },
        set: function (value) {
            if (!this._agreementBlock) {
                throw new Error("Cannot update missing agreement block");
            }
            this._agreementBlock.settings.showNavigation = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(AgreementStore.prototype, "showDownloadButton", {
        get: function () {
            var _a, _b;
            return (_b = (_a = this._agreementBlock) === null || _a === void 0 ? void 0 : _a.settings.showDownloadButton) !== null && _b !== void 0 ? _b : true;
        },
        set: function (value) {
            if (!this._agreementBlock) {
                throw new Error("Cannot update missing agreement block");
            }
            this._agreementBlock.settings.showDownloadButton = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(AgreementStore.prototype, "blockName", {
        get: function () {
            var _a, _b;
            return (_b = (_a = this._agreementBlock) === null || _a === void 0 ? void 0 : _a.name) !== null && _b !== void 0 ? _b : "";
        },
        set: function (value) {
            if (!this._agreementBlock) {
                throw new Error("Cannot update missing agreement block");
            }
            this._agreementBlock.name = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(AgreementStore.prototype, "formButtonText", {
        get: function () {
            var _a, _b, _c;
            return (_c = (_b = (_a = this._agreementBlock) === null || _a === void 0 ? void 0 : _a.settings.form) === null || _b === void 0 ? void 0 : _b.buttonText) !== null && _c !== void 0 ? _c : "Agree";
        },
        set: function (value) {
            if (!this._agreementBlock) {
                throw new Error("Cannot update missing agreement block");
            }
            if (this._agreementBlock.settings.form) {
                this._agreementBlock.settings.form.buttonText = value;
            }
            else {
                this._agreementBlock.settings.form = { buttonText: value };
            }
        },
        enumerable: false,
        configurable: true
    });
    var _a, _b, _c, _d;
    __decorate([
        mobx_1.observable.deep,
        __metadata("design:type", Boolean)
    ], AgreementStore.prototype, "_showModal", void 0);
    __decorate([
        mobx_1.observable.deep,
        __metadata("design:type", Object)
    ], AgreementStore.prototype, "_agreementBlock", void 0);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Object)
    ], AgreementStore.prototype, "onAngularUpdated", void 0);
    __decorate([
        mobx_1.computed,
        __metadata("design:type", Boolean),
        __metadata("design:paramtypes", [])
    ], AgreementStore.prototype, "showModal", null);
    __decorate([
        mobx_1.computed,
        __metadata("design:type", Object),
        __metadata("design:paramtypes", [Object])
    ], AgreementStore.prototype, "block", null);
    __decorate([
        mobx_1.computed,
        __metadata("design:type", Boolean),
        __metadata("design:paramtypes", [Boolean])
    ], AgreementStore.prototype, "showNavigation", null);
    __decorate([
        mobx_1.computed,
        __metadata("design:type", Boolean),
        __metadata("design:paramtypes", [Boolean])
    ], AgreementStore.prototype, "showDownloadButton", null);
    __decorate([
        mobx_1.computed,
        __metadata("design:type", String),
        __metadata("design:paramtypes", [String])
    ], AgreementStore.prototype, "blockName", null);
    __decorate([
        mobx_1.computed,
        __metadata("design:type", String),
        __metadata("design:paramtypes", [String])
    ], AgreementStore.prototype, "formButtonText", null);
    AgreementStore = __decorate([
        (0, inversify_1.injectable)(),
        __param(0, (0, inversify_1.inject)(AngularSyncStore_1.AngularSyncServices.$)),
        __param(1, (0, inversify_1.inject)("angularData")),
        __metadata("design:paramtypes", [typeof (_a = typeof AngularSyncStore_1.AngularSyncServices !== "undefined" && AngularSyncStore_1.AngularSyncServices) === "function" ? _a : Object, Object])
    ], AgreementStore);
    return AgreementStore;
}(AngularSyncStore_1.default));
exports.AgreementStore = AgreementStore;
exports.AgreementModalComponents = (0, DIProvider_1.makeServiceIdentifier)(Symbol("AgreementModalComponents"));
exports.Header = (0, mobx_react_1.observer)(function (props) {
    var type = props.type, onDismiss = props.onDismiss;
    var disableNavigationButton = (0, AgreementContextProvider_1.useAgreementContext)().disableNavigationButton;
    var components = (0, inversify_react_1.useInjection)(exports.AgreementModalComponents.$);
    if (type === "lite") {
        return (react_1.default.createElement(kaleidoscope_1.Stack, { className: styles.header, direction: "horizontal", align: "center", justify: "end" },
            react_1.default.createElement(kaleidoscope_1.Stack, { gap: "xs", paddingRight: "s", direction: "horizontal", align: "center" },
                react_1.default.createElement(kaleidoscope_1.IconButton, { onClick: onDismiss, icon: react_1.default.createElement(icons_1.Close, null), "aria-label": "Close agreement", tooltip: { content: "Close" } }))));
    }
    var agreementStore = props.agreementStore, agreementBlock = props.agreementBlock, formWrapperRef = props.formWrapperRef, navDrawerOpen = props.navDrawerOpen;
    return (react_1.default.createElement(ModalFocusContext.Consumer, null, function (ctx) { return (react_1.default.createElement(kaleidoscope_1.Stack, { className: styles.header, direction: "horizontal", align: "center", justify: "spaceBetween", gap: "xs" },
        react_1.default.createElement(kaleidoscope_1.Stack, { className: styles.headerTitle, gap: "xs", paddingLeft: agreementStore.showNavigation ? "s" : "m", direction: "horizontal", align: "center" },
            agreementStore.showNavigation && (react_1.default.createElement(kaleidoscope_1.IconButton, { onClick: function () {
                    props.setNavDrawerOpen(function (prev) { return !prev; });
                }, icon: react_1.default.createElement(pages_common_1.AnimatedNavigationIcon, { isOpen: navDrawerOpen }), "aria-label": "Menu", ref: ctx === null || ctx === void 0 ? void 0 : ctx.navDrawerButtonRef })),
            react_1.default.createElement(components.BlockTitle, { content: !!agreementStore.blockName ? agreementStore.blockName : "Untitled", onChange: props.isEditable
                    ? function (value) {
                        agreementStore.blockName = value;
                    }
                    : undefined })),
        react_1.default.createElement(kaleidoscope_1.Stack, { gap: "xs", paddingRight: "s", direction: "horizontal", align: "center" },
            !!components.TokensPopover && react_1.default.createElement(components.TokensPopover, { viewOnly: true }),
            !!components.BlockSettings && props.isEditable && (react_1.default.createElement(components.BlockSettings, { store: agreementStore, agreementBlock: agreementBlock })),
            agreementStore.showDownloadButton && (react_1.default.createElement(components.DownloadPdfButton, { setNotificationMessage: props.setNotificationMessage })),
            react_1.default.createElement(MaybeWrap_1.default, { wrapper: function (children) {
                    if (disableNavigationButton) {
                        return (react_1.default.createElement(kaleidoscope_1.Tooltip, { wrapTarget: true, content: "Looks like this agreement has already been accepted.", size: kaleidoscope_1.TooltipSize.Large, autoStack: false }, children));
                    }
                } },
                react_1.default.createElement(kaleidoscope_1.Button, { className: styles.formNavButton, size: kaleidoscope_1.ButtonSize.Medium, disabled: disableNavigationButton, ref: ctx === null || ctx === void 0 ? void 0 : ctx.ctaButtonRef, onClick: function () {
                        if (formWrapperRef.current) {
                            (0, scroll_into_view_if_needed_1.default)(formWrapperRef.current, {
                                behavior: "smooth",
                                scrollMode: "if-needed",
                                block: "start",
                            });
                            (0, Utils_1.focusFirstAcceptFlowElement)();
                        }
                    } },
                    react_1.default.createElement(kaleidoscope_1.Text, { size: "s", strong: true }, !!agreementStore.formButtonText ? agreementStore.formButtonText : "Accept"))),
            react_1.default.createElement(kaleidoscope_1.IconButton, { onClick: onDismiss, icon: react_1.default.createElement(icons_1.Close, null), "aria-label": "Close agreement", tooltip: { content: "Close" } })))); }));
});
var ModalFocusContext = react_1.default.createContext(undefined);
var AgreementModalContainer = function (_a) {
    var onDismiss = _a.onDismiss, showModal = _a.showModal, children = _a.children, modalEscapable = _a.modalEscapable, agreementBlock = _a.agreementBlock;
    var di = (0, inversify_react_1.useInjection)("di");
    var _b = (0, AgreementContextProvider_1.useAgreementContext)(), _c = _b.buttonColor, buttonColor = _c === void 0 ? AcceptButtonSettingsHelper_1.legacyEmerald : _c, isPrintMode = _b.isPrintMode;
    var initialShowModal = (0, react_1.useRef)(showModal);
    var modalContentRef = (0, react_1.useRef)(null);
    var navDrawerButtonRef = (0, react_1.useRef)(null);
    var ctaButtonRef = (0, react_1.useRef)(null);
    (0, react_1.useEffect)(function () {
        if (initialShowModal.current) {
            (0, hydrate_1.hydrate)(modalContentRef.current, "[data-hydration-host]", { di: di });
        }
    }, []);
    return (react_1.default.createElement(MaybeWrap_1.default, { wrapper: function (children) {
            if (!isPrintMode) {
                return (react_1.default.createElement(ModalContainer_1.ModalContainer, { show: showModal, onDismiss: onDismiss, escapeKeyClose: modalEscapable, onEnter: function (node) {
                        var _a;
                        (0, hydrate_1.hydrate)(node, "[data-hydration-host]", { di: di });
                        var elementToFocus = (_a = navDrawerButtonRef.current) !== null && _a !== void 0 ? _a : ctaButtonRef.current;
                        if (elementToFocus) {
                            elementToFocus.focus();
                        }
                    } },
                    react_1.default.createElement(kaleidoscope_1.Layer, { offset: agreementModalOffset }, function (_a) {
                        var _b;
                        var _c, _d;
                        var zIndex = _a.zIndex;
                        return (react_1.default.createElement("div", { className: styles.wrapper, style: { zIndex: zIndex }, "data-qwilr-component": "agreement-modal", ref: modalContentRef },
                            react_1.default.createElement("div", { className: (0, classnames_1.default)("top-level-block-wrapper", styles.container), "data-id": (_c = agreementBlock === null || agreementBlock === void 0 ? void 0 : agreementBlock._id) !== null && _c !== void 0 ? _c : "", "data-block-type": (_d = agreementBlock === null || agreementBlock === void 0 ? void 0 : agreementBlock.type) !== null && _d !== void 0 ? _d : "", style: (0, dynamic_1.assignInlineVars)((_b = {},
                                    _b[styles.navButtonColor] = buttonColor,
                                    _b[styles.navButtonTextColor] = (0, pages_common_1.goldilocks)(buttonColor, { mode: "text" }),
                                    _b)) },
                                react_1.default.createElement(ModalFocusContext.Provider, { value: { navDrawerButtonRef: navDrawerButtonRef, ctaButtonRef: ctaButtonRef } }, children))));
                    })));
            }
        } }, children));
};
